/**
 * A REAL `<a href>` TO AN ADDRESS INSIDE THIS APP, WHICH A PLAIN CLICK FOLLOWS IN PLACE.
 *
 * The sidebar's two rules (`./CabinetShell.tsx`, "THE RULES IT KEEPS"), for a link that sits in a
 * sentence rather than in the nav: the `href` is real, so a new tab, a copied address or a middle
 * click lands on the same screen; and a plain primary click is handed to the app's in-app
 * navigation instead of reloading the page - `./in-app-navigation.ts`, bound to the router in the
 * app and a full page load without one. A modified or non-primary click is left to the browser.
 *
 * Written for the editor's way to the terms interstitial after a submit refused for stale terms
 * (`routes/articles/editor/TermsStaleNotice.tsx`).
 */
import { Anchor } from '@mantine/core';
import type { AnchorProps } from '@mantine/core';
import type { MouseEvent, ReactNode } from 'react';
import { followsInApp, useNavigateToHref } from './in-app-navigation';

export interface InAppAnchorProps extends AnchorProps {
  /** A same-origin path, query included. */
  readonly href: string;
  readonly children: ReactNode;
}

export function InAppAnchor({ href, children, ...anchor }: InAppAnchorProps) {
  const navigate = useNavigateToHref();

  const follow = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!followsInApp(event)) {
      return;
    }
    event.preventDefault();
    navigate(href);
  };

  return (
    <Anchor {...anchor} href={href} onClick={follow}>
      {children}
    </Anchor>
  );
}
